module.exports = __webpack_public_path__ + "static/media/twitter.58c80fb8.svg";